import { ApiDetailResponse } from "../common/interfaces/ApiResponse";
import { apiSlice } from "./apiSlice";

const uploadApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadMedia: builder.mutation({
      query: (file) => ({
        url: "upload",
        method: "POST",
        body: file,
      }),
    }),
    chatAttachments: builder.mutation<
      ApiDetailResponse<{
        attachments: {
          fileName: string;
          filePath: string;
          fileSize: number;
          fileType: string;
          url: string;
        }[];
      }>,
      any
    >({
      query: (file) => ({
        url: "upload/chatAttachment",
        method: "POST",
        body: file,
      }),
    }),
  }),
});

export const { useUploadMediaMutation, useChatAttachmentsMutation } = uploadApi;
